
/**
 * 단건 결제용 주문 세션 생성 요청
 */
export type CreateOrderSessionBody = {
  /**
   * 결제 금액 (원)
   * @minimum 100
   */
  amount: number;
  /**
   * 상품명
   * @maxLength 100
   */
  goodsName: string;
  /**
   * Edusense 강의와 연결된 상품 코드
   * @maxLength 100
   */
  productCode: string;
};
